import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      lastPos: null,
      element: null,
    };
  },
  mounted() {
    if (!this.$refs['resize-handle']) {
      console.error('reseize handle not found');
      return;
    }
    this.element = this.$refs['resize-handle'];
    this.element.parentNode.style.width = this.leftPannelWidth + 'px';

    this.element.addEventListener('mousedown', this.mousedown, { passive: true });
    this.element.addEventListener('touchstart', this.mousedown, { passive: true });

    document.addEventListener('mouseup', this.mouseup, { passive: true });
    document.addEventListener('touchend', this.mouseup, { passive: true });
  },
  methods: {
    mouseup() {
      document.removeEventListener('mousemove', this.resize, false);
      document.removeEventListener('touchmove', this.resize, false);
    },
    mousedown(e) {
      this.lastPos = e.x;
      document.addEventListener('touchmove', this.resize, { passive: true });
      document.addEventListener('mousemove', this.resize, { passive: true });
    },
    resize(e) {
      let parent = this.element.parentNode;
      let dx = 0;
      if (e.changedTouches) {
        dx = this.lastPos - e.changedTouches[0].pageX;
        this.lastPos = e.changedTouches[0].pageX;
      } else {
        dx = this.lastPos - e.x;
        this.lastPos = e.x;
      }
      const newWidth = parseInt(getComputedStyle(parent, '').width) - dx;
      this.$store.dispatch('pannel.left.setWidth', newWidth);
      parent.style.width = newWidth + 'px';
    },
  },
  beforeDestroy() {
    this.element.removeEventListener('touchstart', this.mousedown);
    this.element.removeEventListener('mousedown', this.mousedown);
    document.removeEventListener('mouseup', this.mouseup);
    document.removeEventListener('touchend', this.mouseup);
  },
  computed: {
    ...mapGetters(['leftPannelWidth']),
  },
};
